import React,{Component} from "react";
import {AppBackground, MediumFont, TextColor, ThinBorder} from '../../styles/BaseStyles';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import MoneyCard from "./MoneyCard";
import TimeCard from "./TimeCard";
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { shadows } from '@material-ui/system';
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import {loadLoginData, saveLoginData, updateLoginData, loginAction, logout} from "../../redux/modules/login";
import {bindActionCreators} from "redux";
import { connect } from 'react-redux';
import Image from "material-ui-image";
import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import * as MainConstants from "../../utils/MainConstants";
import {VisibilityOff} from "@material-ui/icons";
import InputMask from "react-input-mask";
import  axios  from 'axios';
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import {Redirect, Link} from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";

//const history = useHistory();
//const navigateToHome=() => { history.push('/home')}


const Styles = theme => ({
    root: Object.assign({}, AppBackground, MediumFont),
    gridPane: {width: '50%', display: 'inline-block'},
    paneTable: {width: '100%', height: '100%',  backgroundColor:'grey'},
    videoPane: {width: '50%', display: 'inline-block', verticalAlign: 'top'},
    penInfoPanel: {color: 'white', fontSize: 20},
    penInfoPanelSelected: Object.assign({color: 'white', fontSize: 20}, ThinBorder),
    videoPanel: {marginTop: 0},
    penName: {color: TextColor, fontSize: 20, marginLeft: 10, cursor: 'pointer', display: 'inline-block'},
    metricValue: {display: 'inline-block', width: 100, height: 100, cursor: 'pointer'},
    container: {
        display: 'grid',
        gridTemplateColumns: 'repeat(12, 1fr)',
        gridGap: `${theme.spacing.unit * 3}px`,
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    divider: {
        margin: `${theme.spacing.unit * 2}px 0`,
    },
    metricInfo: Object.assign({}, AppBackground, ThinBorder),
    multilineColor:{
        color:'red'
    }
    
});

const styles = theme => ({
    container: {
        display: 'grid',
        gridTemplateColumns: 'repeat(12, 1fr)',
        gridGap: `${theme.spacing.unit * 3}px`,
    },
    paper: {
        padding: theme.spacing.unit,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        whiteSpace: 'nowrap',
        marginBottom: theme.spacing.unit,
    },
    divider: {
        margin: `${theme.spacing.unit * 2}px 0`,
    },
    leftPane: {width: '25%', height: '100%', verticalAlign: 'top', backgroundColor:'red'},
    rightPane: {fontSize: 40, color: 'black', verticalAlign: 'top', backgroundcolor:'red'},
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2,
    },
    
    extendedIcon: {
        marginRight: theme.spacing.unit,
    },
    margin: {
        margin: theme.spacing.unit * 2,
    },
    multilineColor:{
        color:'black',
        backgroundColor:'#f5f7e8'
    },
    button: {
        marginTop: theme.spacing.unit * 1,
        marginLeft: theme.spacing.unit,
        backgroundColor: "#09827a",
        width:'95%',
        color: "black",
        border:'2px solid green',
        borderColor:'black',
        height:40,
        fontSize:26,
        '&:hover': {
            backgroundColor: 'white', // Background color on hover
            color: 'black', // Optional: Change text color on hover
        },
        
    },
    buttonsignup2: {
        marginTop: theme.spacing.unit * 1,
        marginLeft: theme.spacing.unit,
        backgroundColor: "#09827a",
        border:'2px solid green',
        borderColor:'black',
        width:'95%',
        color: "black",
        height:40,
        fontSize:16,
        fontWeight:800,
        '&:hover': {
            backgroundColor: 'white', // Background color on hover
            color: 'black', // Optional: Change text color on hover
        },
        
    },
    buttonsignup: {
        marginTop: theme.spacing.unit * 11,
        marginLeft: theme.spacing.unit,
        backgroundColor: "#09827a",
        width:'95%',
        color: "black",
        border:'2px solid green',
        borderColor:'black',
        height:40,
        fontSize:16,
        fontWeight:800,
        '&:hover': {
            backgroundColor: 'white', // Background color on hover
            color: 'black', // Optional: Change text color on hover
        },
        
    },
    buttonnu: {
        marginTop: theme.spacing.unit * 1,
        marginLeft: theme.spacing.unit,
        backgroundColor: "#09827a",
        width:'95%',
        color: "black",
        height:40,
        fontSize:16,
        fontWeight:800,
        '&:hover': {
            backgroundColor: 'white', // Background color on hover
            color: 'black', // Optional: Change text color on hover
        },
        
    }
});


class Signup extends Component {
    
    state = {
        age: '',
        firstname: '',
        lastname:'',
        email:'',
        comment:'',
        userComment:{},
        //userInfo: '',
        passwordString: '',
        showPassword:false,
        slideAnimationDialog:false,
        errorDialog:false,
        passwordHolder:"Password",
        emailHolder:"Email",
        showVerificationDialog:false,
        verificationCode:"",
        showSignupCompleteDialog:false,
        userInfo:{"country":"U.S.A", "state":"Massachusetts", "month":"-", "year":"-"},
        captchaValue:"",
        
    };
    constructor(props) {
        super(props);
        this.errorMessage="";
        this.handleUsernameChange = this.handleUsernameChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleStateChange = this.handleStateChange.bind(this);
        this.handleCountryChange = this.handleCountryChange.bind(this);
        this.handlePhoneChange = this.handlePhoneChange.bind(this);
        this.handleFirstnameChange = this.handleFirstnameChange.bind(this);
        this.handleLastnameChange = this.handleLastnameChange.bind(this);
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleAddress1Change = this.handleAddress1Change.bind(this);
        this.handleAddress2Change = this.handleAddress2Change.bind(this);
        this.handleCityChange = this.handleCityChange.bind(this);
        this.handleZipcodeChange = this.handleZipcodeChange.bind(this);
        this.handleVerificationChange = this.handleVerificationChange.bind(this);
        this.saveAUserOnServer = this.saveAUserOnServer.bind(this);
        this.getArrayOfPostsForSaveAUser = this.getArrayOfPostsForSaveAUser.bind(this);
        this.onErrorOk = this.onErrorOk.bind(this);
        this.onSendVerificationPressed = this.onSendVerificationPressed.bind(this);
        this.setVerificationDialog = this.setVerificationDialog.bind(this);
        this.handleVerificationClose = this.handleVerificationClose.bind(this);
        this.getArrayOfEVerification = this.getArrayOfEVerification.bind(this);
        this.emailVerificationOnServer = this.emailVerificationOnServer.bind(this);
        this.setSignupCompleteDialog = this.setSignupCompleteDialog.bind(this);
        this.handleSignupCompleteClose = this.handleSignupCompleteClose.bind(this);
        this.renderRedirectHome = this.renderRedirectHome.bind(this);
        this.handleCaptchaChange= this.handleCaptchaChange.bind(this);
        this.openInNewTab= this.openInNewTab.bind(this);
        this.cancelPressed= this.cancelPressed.bind(this);
        this.recaptchaRef = React.createRef();
        
        
        
        
        
        
        
    }
    
    handleCountryChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.userInfo,{country:event.target.value}));
    }
    handleStateChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.userInfo,{state:event.target.value}));
    }
    componentDidMount(){
        let { loginAction } = this.props;
        //this.props.auth.login();
        //loginAction();
    }
    
    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };
    
    handleUsernameChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.userInfo,{address2:event.target.value}));
    }
    
    
    handleFirstnameChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.userInfo,{firstName:event.target.value}));
    }
    
    handleLastnameChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.userInfo,{lastName:event.target.value}));
    }
    
    handleEmailChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.userInfo,{email:event.target.value}));
    }
    
    handlePasswordChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.userInfo,{password:event.target.value}));
    }
    handlePhoneChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.userInfo,{phone:event.target.value}));
    }
    
    handleAddress1Change(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.userInfo,{address1:event.target.value}));
    }
    
    handleAddress2Change(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.userInfo,{address2:event.target.value}));
    }
    
    handleCityChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.userInfo,{city:event.target.value}));
    }
    
    handleZipcodeChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.userInfo,{zipcode:event.target.value}));
    }
    
    handleVerificationChange(event) {
        //event.preventDefault();
        this.setState( {verificationCode:event.target.value});
    }
    
    handleSubmit(event) {
        //let { loginToPlatewiz} = this.props;
        event.preventDefault();
        //console.log('Form submitted with reCAPTCHA:', this.state.captchaValue);
        if (this.state.captchaValue) {
            
            this.saveAUserOnServer(DEFAULT_VESPAAN_SERVER.url, this.state.userInfo, this.state.captchaValue);
            // To reset reCAPTCHA manually
            this.recaptchaRef.current.reset();
        } else {
            // Handle case where reCAPTCHA is not solved
            console.log('Please complete the reCAPTCHA');
            alert('Please complete the reCAPTCHA first');
        }
    }
    
    /* This was for without reCaptcha
    handleSubmit() {
        
        
        
        this.saveAUserOnServer(DEFAULT_VESPAAN_SERVER.url, this.state.userInfo);
     
    };*/
    
    //saveAUserOnServer(argURL, argUser, argIdToken,argReCaptchaToken) {
    saveAUserOnServer(argURL, argUser,  argReCaptchaToken) {
        
        var self=this;
        //const { navigate } = self.props.navigation;
        
        
        if ((argURL != null) || (argURL.length != 0)) {
            axios.all(self.getArrayOfPostsForSaveAUser(argURL, argUser,  argReCaptchaToken)).then(function (responses) {
                //self.setSlideAnimationDialog(true);
                //self.setEmailDialog(true);
                //self.props.route.params.navigate("Verification", {email:self.state.userInfoState.email, username:self.state.userInfoState.email, passedUserInfo:self.state.userInfoState});
                //resolve(responses[0]);
                self.setVerificationDialog(true);
            }, function (err) {
                //console.log("Farshid some error occured on saving a users " + err.message +  " the URL is " + argURL );
                //console.log(responses);
                console.log(err);
                console.log(err.message);
                console.log("data");
                console.log(err.response.data.message);
                console.log(err.response.data);
                console.log("status")
                console.log(err.response.status);
                console.log(err.response.headers);
                self.errorMessage = err.response.data.message;
                self.setErrorDialog(true);
                // reject(err);
            });
        }
        
    }
    
    getArrayOfPostsForSaveAUser(argURL, argUser,   argReCaptchaToken) {
        let baseUrl = argURL + "webusers"+"?recaptchatoken="+argReCaptchaToken;
        var arrayOfGets = [];
        if (argURL != null) {
            arrayOfGets.push(axios.post(baseUrl, argUser));
        }
        return arrayOfGets;
    }
    
    /*getArrayOfPostsForSaveAUser(argURL, argUser, argIdToken) {
        let baseUrl = argURL + "users";
        var arrayOfGets = [];
        if (argURL != null) {
            arrayOfGets.push(axios.post(baseUrl, argUser));
        }
        return arrayOfGets;
    }*/
    
    setErrorDialog(argBool){
        this.setState({errorDialog:argBool});
    }
    
    onErrorOk() {
        //Alert.alert("Cancel was pressed Farshid");
        //const { navigate } = this.props.navigator;
        this.setErrorDialog(false);
        //this.props.route.params.navigate("Login", {screen: "LoginPage"});
    }
    
    setSignupCompleteDialog(argBool){
        this.setState({showSignupCompleteDialog:argBool});
    }
    
    handleSignupCompleteClose() {
        this.renderRedirectHome();
        this.setSignupCompleteDialog(false);
        this.setVerificationDialog(false);
        
    }
    
    renderRedirectHome(){
        console.log("Redirecting to Home");
        return <Redirect to='/home' />
        //return <MainView {...props} />
    }
    setVerificationDialog(argBool){
        this.setState({showVerificationDialog:argBool});
    }
    
    handleVerificationClose() {
        this.setVerificationDialog(false);
    }
    onSendVerificationPressed(){
        this.emailVerificationOnServer(DEFAULT_VESPAAN_SERVER.url, this.state.userInfo.email, this.state.verificationCode);
    }
    
    emailVerificationOnServer( argURL, argUsername, argCode){
       // const { navigate } = this.props.navigation;
        //let { updateLoginDataAction} = this.props;
        var self=this;
        
        
        if((argURL != null) || (argURL.length != 0)){
            axios.all(self.getArrayOfEVerification(argURL, argUsername, argCode)).then(function(responses){
                
                console.log(responses[0].data);
                //navigate("Login", {screen: "Login"});
                self.setSignupCompleteDialog(true);
                
            }, function(err) {
                console.log(err);
                console.log("Farshid some error occurred on Email Verification to server " + err.message +  " the URL is " + argURL );
                self.errorMessage = err.response.data.message;
                self.setErrorDialog(true);
                //reject(err);
            });
        }
    }
    
    
    getArrayOfEVerification(argURL, argUsername, argCode){
        
        let baseUrl = argURL+"email/verification";
        console.log(" on posting a login the URL is " + baseUrl );
        
        var arrayOfGets = [];
        if(argURL != null) {
            
            arrayOfGets.push(axios.post(baseUrl, { "username": argUsername,
                "code": argCode}));
        }
        return arrayOfGets;
    }
    
    handleCaptchaChange = (value) => {
        this.setState({ captchaValue: value });
    };
    
    openInNewTab(url) {
        var win = window.open(url, '_self');
        win.focus();
    }
    
    cancelPressed() {
        //this.openInNewTab("/");
        //Route("/");
        //this.renderRedirectHome();
    }
    
    
    render() {
        const { classes } = this.props;
        let usStates = MainConstants.getUSStates();
        let canStates = MainConstants.getCanadaStates();
        let availableCountries = MainConstants.getCountries();
        let months = MainConstants.getMonths();
        let years = MainConstants.getYears();
        return (
          <React.Fragment>
              
              <Grid container spacing={24}>
                  <Grid item xs={3} sm={3}>
                  </Grid>
                  <Grid item xs={6} sm={6} style = { {  backgroundColor:'#f0f7fa', backgroundSize: "cover", height:"100%"}}>
                      <div    >
                          <div id="contactus"     >
                              <Grid container spacing={24}>
                                  
                                  {/*}
                                  <Grid container >
                                      <Grid item xs={24} sm={24}    >
                                          <Grid item xs={3} sm={3}    >
                                          </Grid>
                                          <Grid item xs={6} sm={6}    >
                                              <Image src="/static/images/license2c.png" alt="React Image"  style = { {   resizeMode: 'stretch' ,  width:400}}  />
                                          </Grid>
                                          <Grid item xs={3} sm={3}    >
                                          </Grid>
                                      </Grid>
                                  </Grid>*/}
                                  
                                  <Grid container >
                                      <Grid item xs={2} sm={2}  md={1} lg={1}>
                                      </Grid>
                                      <Grid item xs={12} sm={12}  md={10} lg={10}>
                                          <Typography   style = { { fontSize:40, fontWeight:200, textAlign: 'center', alignSelf: 'center', color:'black', }} >
                                             Signup with {MainConstants.APPLICATION_NAME}&trade;
                                          </Typography>
                                      </Grid>
                                      <Grid item xs={3} sm={3}  md={1} lg={1}>
                                      </Grid>
                                      <Grid item xs={12} sm={12}    style = {{  alignContent:'center' }} >
                                          <TextField id="firstname" name="firstname" label="First Name"    style = {{ marginTop:60,  marginLeft:10, marginRight:10, width:'90%',backgroundColor: "#dcf1f7"}} fullWidth   value={this.state.userInfo.firstName} onChange={this.handleFirstnameChange} />
                                      </Grid>
                                      <Grid item xs={12} sm={12}    style = {{  alignContent:'center' }} >
                                          <TextField id="lastname" name="lastname" label="Last Name"    style = {{ marginTop:10,  marginLeft:10, marginRight:10, width:'90%',backgroundColor: "#dcf1f7"}} fullWidth   value={this.state.userInfo.lastName} onChange={this.handleLastnameChange} />
                                      </Grid>
                                      
                                      <InputMask mask="(999) 999-9999" value={this.state.userInfo.phone} onChange={this.handlePhoneChange} >
                                          
                                          
                                          {() =>  <TextField id="mobile" name="mobile" label="Mobile Phone"    style = {{ marginTop:10,  marginLeft:10, marginRight:10, width:'90%',backgroundColor: "#dcf1f7"}} fullWidth   />}
                                      
                                      </InputMask>
                                      
                                      
                                      
                                      <Grid item xs={12} sm={12}    style = {{  alignContent:'center' }} >
                                          <TextField id="email" name="email" label="Email"    style = {{ marginTop:10,  marginLeft:10, marginRight:10, width:'90%',backgroundColor: "#dcf1f7"}} fullWidth   value={this.state.userInfo.email} onChange={this.handleEmailChange} />
                                      </Grid>
                                      <Grid item xs={12} sm={12} m={'10'}  >
                                          <TextField id="password" name="password" label="Password"  style = {{ marginTop:10, marginLeft:10, marginRight:10, width:'90%', backgroundColor: "#dcf1f7",}} fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.state.userInfo.password} onChange={this.handlePasswordChange} />
                                      </Grid>
                                      <Grid item xs={12} sm={12}    style = {{  alignContent:'center' }} >
                                          <TextField id="addressone" name="addressone" label="Address Line 1"    style = {{ marginTop:10,  marginLeft:10, marginRight:10, width:'90%',backgroundColor: "#dcf1f7"}} fullWidth   value={this.state.userInfo.address1} onChange={this.handleAddress1Change} />
                                      </Grid>
                                      <Grid item xs={12} sm={12}    style = {{  alignContent:'center' }} >
                                          <TextField id="addresstwo" name="addresstwo" label="Address Line 2"    style = {{ marginTop:10,  marginLeft:10, marginRight:10, width:'90%',backgroundColor: "#dcf1f7"}} fullWidth   value={this.state.userInfo.address2} onChange={this.handleAddress2Change} />
                                      </Grid>
                                      <Grid item xs={12} sm={12}    style = {{  alignContent:'center' }} >
                                          <TextField id="city" name="city" label="City"    style = {{ marginTop:10,  marginLeft:10, marginRight:10, width:'90%',backgroundColor: "#dcf1f7"}} fullWidth   value={this.state.userInfo.city} onChange={this.handleCityChange} />
                                      </Grid>
                                      {/*}
                                      <Grid item xs={12} sm={12}    style = {{  alignContent:'center' }} >
                                          <TextField id="country" name="country" label="Country"    style = {{ marginTop:10,  marginLeft:10, marginRight:10, width:'90%',backgroundColor: "#dcf1f7"}} fullWidth   value={this.state.userInfo} onChange={this.handleUsernameChange} />
                                      </Grid>
                                      <Grid item xs={12} sm={12}    style = {{  alignContent:'center' }} >
                                          <TextField id="state" name="state" label="State"    style = {{ marginTop:10,  marginLeft:10, marginRight:10, width:'90%',backgroundColor: "#dcf1f7"}} fullWidth   value={this.state.userInfo} onChange={this.handleUsernameChange} />
                                      </Grid>
                                      */}
                                      <Grid item xs={12} sm={12} md={6} lg={6}>
                                          {/*<TextField  required id="country"  name="country"  label="Country"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.userInfo.country} onChange={this.handleCountryChange} />
                                                                */}
                                          <FormControl className={classes.formControl}>
                                          <InputLabel htmlFor="age-helper">Country</InputLabel>
                                          <Select value={this.state.userInfo.country}
                                                  onChange={ this.handleCountryChange}
                                                  inputProps={{
                                                      name: 'country',
                                                      id: 'country-helper',
                                                  }}
                                          >
                                              
                                              {availableCountries}
                                          
                                          </Select>
                                      
                                      </FormControl>
                                      </Grid>
                                      <Grid item xs={12} sm={12}  md={6} lg={6}>
                                         
                                          <FormControl className={classes.formControl}>
                                              <InputLabel htmlFor="age-helper">State</InputLabel>
                                              <Select value={this.state.userInfo.state}
                                                      onChange={ this.handleStateChange}
                                                      inputProps={{
                                                          name: 'state',
                                                          id: 'state-helper',
                                                      }}
                                              >
                                                  
                                                  {(this.state.userInfo.country == "U.S.A") &&  (usStates) }
                                                  { (this.state.userInfo.country != "U.S.A") && (canStates)}
                                              
                                              
                                              </Select>
                                              {/* <FormHelperText>Select a State </FormHelperText> */}
                                          </FormControl>
                                      
                                      </Grid>
                                      <Grid item xs={12} sm={12}    style = {{  alignContent:'center' }} >
                                          <TextField id="zipcode" name="zipcode" label="Zip Code"    style = {{ marginTop:10,  marginLeft:10, marginRight:10, width:'90%',backgroundColor: "#dcf1f7"}} fullWidth   value={this.state.userInfo.zipcode} onChange={this.handleZipcodeChange} />
                                      </Grid>
                                      
                                      
                                      
                                      <Grid item xs={12} sm={12}  md={4} lg={4}  style = {{  marginBottom:20 }}  >
                                          {/*} <Button variant="contained" color="primary" onClick={this.handleSubmit}   className={classes.buttonnu}   >
                                              New user ?
                                          </Button>*/}
                                          
                                          
                                          {/*} <Button variant="contained" color="primary"   onClick={this.cancelPressed}   className={classes.buttonsignup}   >
                                                  cancel
                                              </Button>*/}
                                          
                                          {/*<Link to="/home/#basic-tabs"    >
                                              <Button variant="contained" color="primary"   className={classes.buttonsignup}   >
                                                  cancel
                                              </Button>
                                          </Link>*/}
                                          <a href="/home"   rel="noreferrer">
                                              <Typography component="h1" variant="h6" style = { { color:'blue',  marginTop:30}} >
                                                  &lArr; TowWatch Home
                                              </Typography>
                                          </a>
                                          
                                          
                                          
                                          {/*<a href="/"  rel="noreferrer" >
                                              <Button variant="contained" color="primary"   className={classes.buttonsignup}   >
                                                  cancel
                                              </Button>
                                          </a>*/}
                                      </Grid>
                                      <Grid item  xs={12} sm={12}  md={7} lg={7}  style = {{  marginBottom:20 }} >
                                          
                                          <form onSubmit={this.handleSubmit}>
                                              
                                              <ReCAPTCHA
                                                //sitekey="6LdjmQ0rAAAAADU4GZUVtQmSXHSH-EBY11cjrAGx" // Replace with your actual site key
                                                sitekey={MainConstants.RECAPTCHASITEKEY }
                                                size="normal" // Use "invisible" for reCAPTCHA v3 or "normal" for v2
                                                ref={this.recaptchaRef}
                                                onChange={this.handleCaptchaChange}
                                                badge="bottomright" // Adjust badge position as needed
                                                style = {{  display:'flex', marginBottom:1, marginTop:2, justifyContent:'center',  alignItems: 'center', }}  />
                                              <Button type="submit" variant="contained" color="primary"  className={classes.buttonsignup2  } >Signup</Button>
                                          </form>
                                          
                                          
                                          
                                          
                                          {/*}
                                          <Button variant="contained" color="primary" onClick={this.handleSubmit}   className={classes.button}   >
                                              Signup
                                          </Button>*/}
                                      </Grid>
                                  </Grid>
                              </Grid>
                          </div>
                      </div>
                  
                  </Grid>
                  <Grid item xs={3} sm={3}>
                  </Grid>
                  <Dialog
                    open={this.state.errorDialog}
                    onClose={ this.onErrorOk}
                    scroll={'paper'}
                    classes={{
                        paper: classes.formControl2,
                    }}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                    maxWidth="xl"
                  >
                      <DialogTitle id="scroll-dialog-title">Error</DialogTitle>
                      <DialogContent id="farshids" dividers="paper">
                          <div>
                              <Typography   style = { { marginTop:20, fontSize:16, fontWeight:400, textAlign: 'left', alignSelf: 'left', color:'black', }} >
                                  Sign up Error!
                              </Typography>
                              <Typography   style = { { marginTop:20, fontSize:16, fontWeight:400, textAlign: 'left', alignSelf: 'left', color:'black', }} >
                                  {this.errorMessage}
                              </Typography>
                              <Typography   style = { { marginTop:20, fontSize:16, fontWeight:400, textAlign: 'left', alignSelf: 'left',  color:'black', }} >
                                  Please correct and submit again.
                              </Typography>
                          </div>
                      </DialogContent>
                      <DialogActions>
                          <Button onClick={this.onErrorOk} color="secondary">Ok</Button>
                      </DialogActions>
                  </Dialog>
                  
                  
                  <Dialog
                    open={this.state.showVerificationDialog}
                    onClose={this.handleVerificationClose}
                    scroll={'paper'}
                    classes={{
                        paper: classes.formControl2,
                    }}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                    maxWidth="xl"
                  >
                      <DialogTitle id="scroll-dialog-title">Verification</DialogTitle>
                      <DialogContent id="farshids" dividers="paper">
                          <div>
                              <Typography   style = { { marginTop:20, fontSize:16, fontWeight:400, textAlign: 'left', alignSelf: 'left', color:'black', }} >
                                  We sent you a code.
                              </Typography>
                              <Typography   style = { { marginTop:20, fontSize:16, fontWeight:400, textAlign: 'left', alignSelf: 'left',  color:'black', }} >
                                  Please check your email : {this.state.userInfo.email}
                              </Typography>
                              <Grid item xs={12} sm={12} md={12} lg={12}   >
                                  <TextField id="pwemail" name="pwpassword" label="Code" style = {{ marginTop:10, marginLeft:1, marginRight:10, width:'90%', backgroundColor: "#e1f2f1",}} fullWidth  value={this.state.verificationCode} onChange={this.handleVerificationChange} />
                              </Grid>
                              <Typography   style = { { marginTop:20, fontSize:16, fontWeight:400, textAlign: 'left', alignSelf: 'left', color:'black', }} >
                                  Enter Account Key Code
                              </Typography>
                          
                          </div>
                      </DialogContent>
                      <DialogActions>
                          <Button onClick={this.onSendVerificationPressed} color="secondary">Submit</Button>
                      </DialogActions>
                  </Dialog>
                  
                  <Dialog
                    open={this.state.showSignupCompleteDialog}
                    onClose={this.handleSignupCompleteClose}
                    scroll={'paper'}
                    classes={{
                        paper: classes.formControl2,
                    }}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                    maxWidth="xl"
                  >
                      <DialogTitle id="scroll-dialog-title">Signup Complete</DialogTitle>
                      <DialogContent id="farshids" dividers="paper">
                          <div>
                              <Typography   style = { { marginTop:20, fontSize:16, fontWeight:400, textAlign: 'left', alignSelf: 'left', color:'black', }} >
                                  Sign up is complete.
                              </Typography>
                              <Typography   style = { { marginTop:20, fontSize:16, fontWeight:400, textAlign: 'left', alignSelf: 'left',  color:'black', }} >
                                  You will be returned to Login screen.
                              </Typography>
                          </div>
                      </DialogContent>
                      <DialogActions>
                          <a href="/home/#basic-tabs"  rel="noreferrer">
                              <Button variant="contained" color="primary"   className={classes.buttonnu}   >
                                  Ok
                              </Button>
                          </a>
                          {/*<Button onClick={this.handleSignupCompleteClose} color="secondary">Ok</Button>*/}
                      </DialogActions>
                  </Dialog>
              </Grid>
          </React.Fragment>
        
        
        );
    }
}


Signup.propTypes = {
    classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => {
    return {
        //accountsArray: state.account.accountsArray,
        //CompanyDeleteResponse:state.account.deleteCompanyResp,
        //CompanySaveResponse:state.account.saveCompanyResp,
        //locationsArray:state.location.locationsArray,
        //vcArray:state.videocontroller.vcArray,
        //camerasArray:state.camera.camerasArray,
        //errorCMsg:state.account.errorCMsg,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        loginAction:loginAction,
        
        
    }, dispatch);
};

//export default withStyles(styles)(AppView);
//export default connect(mapStateToProps, mapDispatchToProps)(AppView);



/*Login.propTypes = {
		classes: PropTypes.object.isRequired,
};*/
//export default withStyles(styles)(Login);
//export default connect(mapStateToProps, mapDispatchToProps)(Login);
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Signup));
